import { render, staticRenderFns } from "./class-info.vue?vue&type=template&id=326e656c&scoped=true"
import script from "./class-info.vue?vue&type=script&lang=js"
export * from "./class-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e656c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326e656c')) {
      api.createRecord('326e656c', component.options)
    } else {
      api.reload('326e656c', component.options)
    }
    module.hot.accept("./class-info.vue?vue&type=template&id=326e656c&scoped=true", function () {
      api.rerender('326e656c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/detail-pane/class-info.vue"
export default component.exports